import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

import { SpotsService } from '../../providers/spots/spots.service';
import { AuthentificationService } from '../../providers/Global/authentification.service';

import { Globals } from '../../ressources/variables/globals';

@Component({
  selector: 'app-spots',
  templateUrl: './spots.component.html',
  styleUrls: ['./spots.component.scss']
})
export class SpotsComponent implements OnInit {

  permissions: Array<string> = [];

  modificationCode = new UntypedFormControl(null, Validators.required);

  range = new UntypedFormGroup({
    start: new UntypedFormControl(null, Validators.required),
    end: new UntypedFormControl(null, Validators.required)
  });

  stations = new UntypedFormControl(null, Validators.required);
  spots = new UntypedFormControl(null, Validators.required);
  slots = new UntypedFormControl(null, Validators.required);
  campagneName = new UntypedFormControl(null, Validators.required);

  dataList: DataList = {
    stations: [],
    slots: [],
    spots: []
  };

  displayedColumns: string[] = ['id', 'name', 'periode', 'stations', 'slot', 'spots_awaiting_scheduling', 'spots_scheduled', 'delete_remaining_spots'];
  mediasMatTable;

  constructor(private router: Router,
              private spotsService: SpotsService,
              private sanitizer: DomSanitizer,
              private iconRegistry: MatIconRegistry,
              private snackBar: MatSnackBar,
              private authentificationService: AuthentificationService) {
    this.permissions = this.authentificationService.permissionsSource.getValue();
    iconRegistry.addSvgIcon('delete', sanitizer.bypassSecurityTrustResourceUrl('assets/icon/delete.svg'));
  }

  ngOnInit() {
    if (this.permissions.includes('edit_winmedia_spots')) {
      this.spotsService.getWinmediaSpotsData()
        .then(res => {
          console.log(res);
          this.dataList = res;
        })
        .catch(err => console.error(err));
      this.spotsService.getPreviousCampaigns()
        .then(res => {
          console.log(res);
          this.mediasMatTable = new MatTableDataSource(res);
        })
        .catch(err => console.error(err));
    }
  }

  deleteRemainingSpots(element) {
    if (this.modificationCode.value === Globals.codeModificationSpots) {
      console.log('deleteRemainingSpots', element);
      if (this.permissions.includes('edit_winmedia_spots')) {
        this.spotsService.deleteRemainingSpots(element.id)
          .then(r => {
            console.log(r);
            delete this.mediasMatTable;
            this.spotsService.getPreviousCampaigns()
              .then(res => {
                console.log(res);
                this.mediasMatTable = new MatTableDataSource(res);
              })
              .catch(err => console.error(err));
            this.snackBar.open(`La spots ont bien été supprimés.`);

          })
          .catch(err => {
            console.error(err);
            this.snackBar.open(`Une erreur est survenue.`);
          });
      }
    } else {
      this.snackBar.open(`Le code d'édition n'est pas valide.`);
    }
  }

  nextPage() {
    /*console.log('range', this.range.value, this.range.valid);
    console.log('stations', this.stations.value, this.stations.valid);
    console.log('spots', this.spots.value, this.spots.valid);
    console.log('slots', this.slots.value, this.slots.valid);
    console.log('campagneName', this.campagneName.value, this.campagneName.valid);*/
    if (this.modificationCode.value === Globals.codeModificationSpots) {
      const globalValidation = (this.range.valid && this.stations.valid && this.spots.valid && this.slots.valid && this.campagneName.valid);
      const allData = {
        sendValid: globalValidation,
        res : {
          range: {
            valid: this.range.valid,
            data: this.range.value
          },
          stations: {
            valid: this.stations.valid,
            data: this.stations.value
          },
          spots: {
            valid: this.spots.valid,
            data: this.spots.value
          },
          slots: {
            valid: this.slots.valid,
            data: this.slots.value
          },
          campagneName: {
            valid: this.campagneName.valid,
            data: this.campagneName.value
          }
        }
      };
      console.log(allData);
      if (allData.sendValid) {
        this.spotsService.passData = allData.res;
        this.router.navigate(['spotsProg']).then(res => {
          console.log(res);
        });
      }
    } else {
      this.snackBar.open(`Le code d'édition n'est pas valide.`);
    }
  }

  returnSpotName(spot) {
    return spot.Performer + ' - ' + spot.Title + ' - ' + spot.Version;
  }
}

export class DataListStation {
  IStation: number;
  Name: string;
}

export class DataListSpot {
  IMedia: number;
  Performer: string;
  Title: string;
  Version: string;
}

export class DataListSlot {
  IMedia: number;
  Performer: string;
  Title: string;
  Version: string;
}

export class DataList {
  stations: DataListStation[];
  slots: DataListSlot[];
  spots: DataListSpot[];
}
